<template>
    <div class="dropdown" ref="dropdown" :id="id + '-area'">
        <div class="form-control d-flex justify-content-between pointer"
            :class="{
                'form-control-sm': small,
                'form-control-lg': large,
            }"
            ref="caption"
            @click.stop="toggle"
            @keydown.enter.prevent="toggle"
            @keydown.space.prevent="toggle"
            tabindex="0"
            :id="id">
            <div>
                <div v-for="(s, i) in selected" :key="id + '-' + i" :class="{
                    'multibox d-inline-flex justify-content-between': multiple,
                }">
                    <span v-html="s[label]"></span>
                    <i class="fa-solid fa-xmark btn-remove" @click.stop="remove(i)" data-bs-auto-close="false"></i>
                </div>
                <span v-if="!selected || selected.length == 0" class="text-placeholder">
                    {{placeholder}}
                </span>
            </div>
            <div>
                <i class="fa-solid fa-angle-down"></i>
            </div>
        </div>
        <ul class="dropdown-menu" ref="dropdownMenu">
            <li>
                <div class="px-1 pb-2">
                    <input type="text" v-model="filter" class="form-control shadow-none" ref="filter"
                    @keydown="navigation"
                    @click.stop="">
                </div>
            </li>
            <li class="menu-list">
                <div v-for="(v, i) in filteredOptions" :key="id + ':' + i" :ref="'item-' + i">
                    <a href="#" class="dropdown-item"
                        :class="{active: i == selectedIndex}"
                        @click.prevent="selectItem(v)"
                        tabindex="-1"
                        v-html="v[label]"></a>
                </div>
            </li>
        </ul>
    </div>
</template>

<style scoped lang="scss">
.multibox {
    border: 1px solid #ddd;
    border-radius: .5rem;
    padding: .2rem .5rem;
    margin: .2rem;
    font-size: .7rem;
}
.btn-remove {
    font-size: 1rem;
    margin: .2rem;
    cursor: pointer;
    &:hover {
        color: royalblue;
    }
}
.form-control {
    &.show {
        border-color: #0d6efd;
    }
    &:focus {
        outline: none;
        border-color: #86b7fe;
        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
    }
}
.dropdown-menu {
    max-height: calc(100vh - 500px);
    overflow: hidden;
    .menu-list {
        max-height: calc(100vh - 560px);
        overflow: scroll;
    }
}
.text-placeholder {
    color: #aaa;
}
.dropdown-item {
    padding: .5rem;
}
</style>

<script>
export default {
    emits: ["update:modelValue", "change"],
    props: {
        multiple: {
            default: false,
            type: Boolean
        },
        modelValue: {
        },
        options: {
            default: []
        },
        label: {
            default: "label"
        },
        small: {
            default: false,
        },
        large: {
            default: false,
        },
        placeholder: {
            default: ""
        },
    },
    data() {
        return {
            filter: "",
            id: null,
            selectedIndex: 0,
        }
    },
    methods: {
        selectItem(v) {
            let items;
            if (this.multiple) {
                if (!this.modelValue) {
                    items = [];
                } else {
                    items = this.modelValue.concat();
                }
                for (const i of items) {
                    const isEuqual = _.isEqual(i,v);
                    if (isEuqual) return;
                }
                items.push(v);
            } else {
                items = v;
            }
            this.$emit("update:modelValue", items);
            this.$emit("change");
            this.$refs.caption.focus();
        },
        remove(i) {
            let items;
            if (this.multiple) {
                items = this.modelValue.concat();
                items.splice(i, 1);
            } else {
                items = null;
            }
            this.$emit("update:modelValue", items);
            this.$emit("change");
        },
        toggle() {
            $(this.$refs.dropdownMenu).css("maxWidth", $(this.$refs.dropdown)[0].clientWidth);
            this.dropdown.toggle();
            this.$refs.filter.focus();
        },
        hide() {
            this.dropdown.hide();
        },
        uniqid() {
            const strong = 1000;
            return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16);
        },
        scrollToSelected() {
            this.$nextTick(() => {
                const itemRef = this.$refs['item-' + this.selectedIndex];
                if (itemRef && itemRef[0]) {
                    itemRef[0].scrollIntoView({
                        block: 'nearest',
                        behavior: 'smooth'
                    });
                }
            });
        },
        navigation(ev) {
            if (ev.isComposing) return;
            if (this.filteredOptions.length == 0) {
                this.selectedIndex = 0;
                return;
            }
            if (ev.key === "ArrowDown") {
                this.selectedIndex = (this.selectedIndex + 1) % this.filteredOptions.length;
                this.scrollToSelected();
            } else if (ev.key === "ArrowUp") {
                this.selectedIndex = (this.selectedIndex - 1 + this.filteredOptions.length) % this.filteredOptions.length;
                this.scrollToSelected();
            } else if (ev.key === "Enter") {
                this.selectItem(this.filteredOptions[this.selectedIndex]);
                this.hide();
            } else if (ev.key === "Escape") {
                this.hide();
            }
        },
    },
    computed: {
        filteredOptions() {
            return _.filter(this.options, (o) => {
                const regex = new RegExp(this.filter, "i");
                return o[this.label].match(regex);
            });
        },
        selected() {
            if (!this.modelValue) {
                return null;
            }
            if (Array.isArray(this.modelValue)) {
                return this.modelValue;
            } else {
                return [this.modelValue];
            }
        },
    },
    mounted() {
        this.id = 'dropdown-' + this.uniqid();
        setTimeout(() => {
            this.dropdown = new bootstrap.Dropdown(document.getElementById(this.id), {
                autoClose: "outside"
            });
            document.addEventListener('click', () => {
                this.dropdown.hide();
            });
            document.getElementById(this.id).addEventListener('show.bs.dropdown', (e) => {
                const index = this.options.findIndex(o => {
                    return o?.id == this.modelValue?.id;
                });
                if (index >= 0) {
                    this.selectedIndex = index;
                }
                this.scrollToSelected();
            });
            const dropdown = document.querySelector('#' + this.id + '-area');
            dropdown.addEventListener('focusout', ev => {
                if (!dropdown.contains(ev.relatedTarget)) {
                    this.hide();
                }
            });
        });
    }
}
</script>
